export default "__VITE_ASSET__h11kgbN6__"